import { render, staticRenderFns } from "./multi-user-role-editor.vue?vue&type=template&id=848c46e6&scoped=true&"
import script from "./multi-user-role-editor.vue?vue&type=script&lang=js&"
export * from "./multi-user-role-editor.vue?vue&type=script&lang=js&"
import style0 from "./multi-user-role-editor.vue?vue&type=style&index=0&id=848c46e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848c46e6",
  null
  
)

export default component.exports